var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifyingGlassPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90625 8.15628H10.4062M8.15625 5.90628V10.4063M12.3324 12.3326L15.7496 15.7498M14.0625 8.15601C14.0625 11.4179 11.4182 14.0623 8.15625 14.0623C4.89432 14.0623 2.25 11.4179 2.25 8.15601C2.25 4.89407 4.89432 2.24976 8.15625 2.24976C11.4182 2.24976 14.0625 4.89407 14.0625 8.15601Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassPlus);
export default __webpack_public_path__ + "static/media/MagnifyingGlassPlus.3738d0133ceeeb318f182c9c27088eac.svg";
export { ForwardRef as ReactComponent };